var _rect, _path, _rect2, _path2, _rect3, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlphaDevs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.59247,
    width: 33.2851,
    height: 33.2851,
    rx: 4.99276,
    transform: "rotate(13.1855 7.59247 0)",
    fill: "url(#paint0_linear_723_2)",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5619 19.0923L25.3983 19.9911L16.7414 28.1517L18.4385 20.9077L14.6021 20.0089L23.259 11.8483L21.5619 19.0923Z",
    fill: "#F3F3F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.218384,
    y: 7.32092,
    width: 33.2851,
    height: 33.2851,
    rx: 4.99276,
    transform: "rotate(-12.3207 0.218384 7.32092)",
    fill: "url(#paint1_linear_723_2)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0474 18.5372L24.897 17.6964L20.5978 28.7894L19.0102 21.5206L15.1607 22.3614L19.4598 11.2685L21.0474 18.5372Z",
    fill: "#F3F3F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.32898,
    y: 3.32849,
    width: 33.2851,
    height: 33.2851,
    rx: 4.99276,
    fill: "url(#paint2_linear_723_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.011 13.6508L13.2523 25.4095V27.9711H14.9319V26.2494L26.6907 14.4906V11.9711H25.011V13.6508ZM26.7747 17.0101C26.7284 17.0101 26.6909 17.0479 26.6907 17.0941V25.3744C26.6907 25.3966 26.682 25.4182 26.6663 25.434L25.8753 26.225C25.8596 26.2406 25.8379 26.2494 25.8157 26.2494H17.5355C17.4893 26.2496 17.4515 26.2871 17.4515 26.3334V27.8451C17.4515 27.8913 17.4893 27.9289 17.5355 27.9291H26.6556C26.6778 27.9291 26.6994 27.9203 26.7151 27.9047L28.346 26.2738C28.3617 26.2581 28.3704 26.2365 28.3704 26.2142V17.0941C28.3702 17.0479 28.3327 17.0101 28.2864 17.0101H26.7747ZM13.2874 11.9711C13.2652 11.9711 13.2436 11.9799 13.2278 11.9955L11.597 13.6263C11.5813 13.6421 11.5726 13.6637 11.5726 13.6859V22.806C11.5728 22.8523 11.6103 22.89 11.6566 22.89H13.1683C13.2145 22.89 13.2521 22.8523 13.2523 22.806V14.5258C13.2523 14.5035 13.261 14.4819 13.2767 14.4662L14.0677 13.6752C14.0834 13.6596 14.1051 13.6508 14.1273 13.6508H22.4075C22.4537 13.6505 22.4915 13.613 22.4915 13.5668V12.0551C22.4915 12.0088 22.4537 11.9713 22.4075 11.9711H13.2874Z",
    fill: "#FAF4F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_723_2",
    x1: 7.59247,
    y1: 0,
    x2: 41.435,
    y2: 0.576838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_723_2",
    x1: 0.218384,
    y1: 7.32092,
    x2: 34.0609,
    y2: 7.89776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_723_2",
    x1: 3.32898,
    y1: 3.32849,
    x2: 37.1715,
    y2: 3.90533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlphaDevs);
export default __webpack_public_path__ + "static/media/IconAlphaDevs.8e690fa5d9123ec001b0cc34156ca728.svg";
export { ForwardRef as ReactComponent };